import React from "react";
import styled from "styled-components";
import { RequiredTheme, ResponsiveValue, ThemeValue } from "styled-system";
import { Box } from "../Box";
import { FadeBox } from "../FadeBox";
import { Flex } from "../Flex";
import { Icon } from "../Icon";
import { Title } from "../Title";

interface Props {
  title: string;
  show?: boolean;
  titleFontSize?: ResponsiveValue<ThemeValue<"fontSizes", RequiredTheme>, RequiredTheme>;
  handleClick: () => void;
}
const StyledFlex = styled(Flex)`
  cursor: pointer;
`;

export const Accordion: React.FC<Props> = ({ title, children, handleClick, show }) => {
  return (
    <Flex flexDirection="column">
      <StyledFlex onClick={handleClick} justifyContent="space-between" alignItems="center" border="2px solid" borderRadius="4px" px={3}>
        <Box width="100%" pr={3}>
          <Title as="h4" my={3}>
            {title}
          </Title>
        </Box>
        <Icon icon={show ? "angle-up" : "angle-down"} fontWeight={500} />
      </StyledFlex>
      <FadeBox show={show}>{children}</FadeBox>
    </Flex>
  );
};

Accordion.defaultProps = {
  show: false,
  titleFontSize: 5,
};
